module.exports = __webpack_public_path__ + "img/logo.878a8198.svg";